import { useEffect, useState } from "react";
import withLoader from "../layouts/WithLoader";
import { useNavigate } from "react-router-dom";
import SellingService from "../../services/SellingService";
import { BillsWithRoute } from "../../models/Bills";
import { BCModelPayementWithRoute } from "../../models/BCModelPayement";
import BCService from "../../services/BC";





const ListBillVenteV2=({ startLoading, stopLoading })=>{

    const [alertMessage, setAlertMessage] = useState("");
    const [alertMessageInPayedBill, setAlertMessageInPayedBill] = useState("");
    const [alertMessagePayedBill, setAlertMessagePayedBill] = useState("");
    const [alertMessageInPayedBD, setAlertMessageInPayedBD] = useState("");
    const [alertMessagePayedBD, setAlertMessagePayedBD] = useState("");
    const [isEmptyPayedBills, setIsEmptyPayedBills] = useState(false);
    const [isEmptyNotPayedBills, setIsEmptyNotPayedBills] = useState(false);
    const [isEmptyBDCBills, setIsEmptyBDCBills] = useState(false);
    const [bills, setBills] = useState([]);
    const [BC, setBC] = useState([]);
    // const [billPayed, setBillPayed] = useState([]);
    const [dataRendred, setDataRendred] = useState(true);
    const [checkVariable, setCheckVariable] = useState("");
  
    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.removeItem("idBill");
        localStorage.removeItem("idBill");
        setAlertMessage("");
        setAlertMessageInPayedBill("");
        setAlertMessagePayedBill("");
        setAlertMessageInPayedBD("");
        setAlertMessagePayedBD("");
        setIsEmptyPayedBills(false);
        setIsEmptyNotPayedBills(false);
        setIsEmptyBDCBills(false);
        setBills([]);
        setDataRendred(true);
        setCheckVariable("");
        setCheckVariable(localStorage.getItem("AllBills"));
        startLoading()
        SellingService.getAllDocumentsSalesByFilterForPayementTask(
            localStorage.getItem("payedOrNotPayed"),
            localStorage.getItem("idSociete"),
            localStorage.getItem("finalMonth"),
            localStorage.getItem("finalYear"),
            1
          )
            .then((response) => {
              if (response.data["success"] !== undefined) {
               
                  setBills(response.data["success"])
                setDataRendred(false)
              } else if (response.data["empty"] !== undefined) {
                // this.setState({ dataRendred: false });
                setIsEmptyBDCBills(true)
              }
            })
            .catch((error) => {
                setAlertMessage("error "+error)
            }).finally(()=>{
                stopLoading()
            })
      }, []);
    //   const deleteBC = (idBC) => {
    //     BCService.deleteBCDraft(idBC)
    //       .then((response) => {
    //         console.log("response", response.data["BC"]);
    //         if (response.data["Bill"] === "not deleted") {
    //           setAlertMessage("error");
    //         } else {
    //           setAlertMessage("success");
    //         }
    //       })
    //       .catch((error) => {
    //         //original    setAlertMessage("error");
    //         setAlertMessage("success");
    //       });
    //   };
    
      const testDocumentList = () => {
        if (BC.length !== 0) {
          return <BCModelPayementWithRoute BC={BC} />;
        } else if (bills.length === 0) {
          return (
            <BillsWithRoute
              bills={bills}
              msg="Les factures "
              msgEmpty="Pas de facture non payée"
              type="0"
            />
          );
        } else if (bills.length !== 0) {
          return (
            <BillsWithRoute
              bills={bills}
              msg="Les factures "
              msgEmpty="Pas de facture non payée"
              type="0"
            />
          );
        }
      };
    
      return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
          <br />
          <section className="content">
            {testDocumentList()}
            <br />
            <br />
          </section>
        </div>
      );
    

}
export default withLoader(ListBillVenteV2);